import { type ValueOf } from '@/lib/utils/type'

export const NOTIFICATIONS_PER_PAGE = 8

export const DASHBOARD_TAB_VALUE = {
  caseUpdates: 'case-updates',
  generalInfo: 'general-info',
}
export type DASHBOARD_TAB_VALUE = ValueOf<typeof DASHBOARD_TAB_VALUE>
export const DASHBOARD_TABS = [
  {
    label: 'Case Updates',
    value: DASHBOARD_TAB_VALUE.caseUpdates,
  },
  {
    label: 'General Info',
    value: DASHBOARD_TAB_VALUE.generalInfo,
  },
]
